import { apiRequest } from '../pages/ConversationPage/apis/client';

import { BookingSystem, User } from './types';

// Request type for updating user
export interface UpdateUserRequest {
  name?: string;
  plan?: 'basic' | 'professional' | 'enterprise';
  skr?: 'SKR03' | 'SKR04';
  paused?: boolean;
  companyName?: string;
  businessField?: string;
  preferredLanguage?: string;
  isSmallBusiness?: boolean;
  datevBeraternummer?: string;
  datevMandantennummer?: string;
  bookingSystem?: BookingSystem;
}

// Get current user details
export const getCurrentUser = async (token: string): Promise<User> => {
  return apiRequest<User>({
    endpoint: '/users/me',
    method: 'GET',
    token,
  });
};

// Update current user details
export const updateUser = async (
  data: UpdateUserRequest,
  token: string
): Promise<User> => {
  return apiRequest<User>({
    endpoint: '/users/me',
    method: 'PATCH',
    body: data,
    token,
  });
};
